import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const RETURN_TASK_EXCEPTION_HELP: HelpContent[] = [
    {
        helpContentId: 'return-task-exception.exception-button',
        tooltipText: 'Re-assign or rescind the current task.'
    }
];
